<template>
  <div class="mod-products-wrapper">
    <div class="product-item mod-card passenger-card">
      <div class="product-head clearfix">
        <img
          class="f-left"
          v-if="productBase[type]?.isUseIcon ?? true"
          :src="productBase[type]?.icon"
          alt
        />
        <div class="f-left">
          <p class="title">{{ productBase[type]?.title }}</p>
          <!-- <slot name="desc"></slot> -->
          <!-- 卡券链接：单个或者列表 -->
          <p class="des">
            <router-link v-if="productBase[type].url" :to="productBase[type].url">{{ productBase[type]?.link}}</router-link>
            <router-link v-else class="links" v-for="item in cardAgreement" :to="item.url" :key="item.url" target="_blank">{{ item.name }}</router-link>
          </p>
        </div>
        <div
          class="f-right extra"
        >
          <a-checkbox @change="onCheck" :checked="show" :disabled="disabled">使用卡券
          </a-checkbox>
        </div>
      </div>
      <div class="product-main" v-if="show">
        <div class="cell-body">
          <a-spin :spinning="loading">
            <div v-if="!loading && !coupons?.length" class="empty">
              暂时没有可使用的卡券。
            </div>
            <card-group
              v-else
              :coupons="coupons"
              @change="onChange"
            >
            </card-group>
          </a-spin>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardGroup from '@/components/coupon/card-group'

export default {
  data () {
    return {
      show: false,
      selectedCoupon: {}
    }
  },
  props: {
    cardCoupons: {
      type: Array,
      default: () => {
        return []
      }
    },
    usedCardCoupons: {
      type: Array,
      default: () => {
        return []
      }
    },
    type: {
      type: String,
      required: true
    },
    loading: Boolean,
    cardAgreement: Array,
    productBase: Object,
    disabled: Boolean

  },
  computed: {
    coupons () {
      const { cardCoupons, usedCardCoupons } = this
      const coupons = []
      cardCoupons.forEach((item) => {
        // 处理卡券勾选问题
        const checked = usedCardCoupons.includes(item.couponCode)
        coupons.push({ ...item, checked })
      })
      return coupons
    }
  },
  watch: {
    valid (value) {
      if (!value.valid) {
        this.show = false
      }
    }
  },
  methods: {
    onCheck () {
      this.show = !this.show
      this.$emit('visible', this.show)
    },
    onChange (value) {
      this.selectedCoupon = value
      this.$emit('change', this.selectedCoupon)
    }
  },
  components: {
    CardGroup
  }
}
</script>

<style lang="less">
  .mod-card.passenger-card {

    .product-head {
      h3 {
        line-height: 70px;
      }
    }
    .product-main {
      padding: 10px;
      .cell-body {
        padding-top: 10px;
        padding-bottom: 15px;
        .action {
          display: inline-block;
          padding-top: 16px;
          vertical-align: top;
        }

        .empty {
          text-align: center;
          color: #888;
          font-size: 14px;
          margin-top: 15px;
        }
      }
    }

    .card-warn {
      color: @primary-color;
      font-size: 14px;
    }
  }
</style>
